import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Error.module.scss';

type Props = React.PropsWithChildren<HTMLAttributes<HTMLParagraphElement>> & {
  /** @deprecated Use className instead */
  classes?: {
    error?: string;
  };
};

export default function Error({
  children,
  className,
  classes,
  ...props
}: Props): JSX.Element {
  return (
    <p
      className={classNames(styles.error, className, classes?.error)}
      {...props}
    >
      {children}
    </p>
  );
}
